import React from 'react';
import PropTypes from 'prop-types';
import { StyledHeroBadges } from './styles.js';
import { HeroBadge } from './HeroBadge.js';

export const HeroBadges = ({ badges = [], fontColor }) => {
  return (
    <StyledHeroBadges>
      {badges.map((item, index) => (
        <HeroBadge {...item} key={index} index={index} fontColor={fontColor} />
      ))}
    </StyledHeroBadges>
  );
};

HeroBadges.displayName = 'HeroBadges';

HeroBadges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  fontColor: PropTypes.string,
};
